<template>
  
    <div class="flex justify-content-between flex-wrap">
        <div class="flex align-items-center justify-content-center">
            <div class="grid">
                <div class="col-5">
                    <Dropdown v-model="selectedFy" :options="globalConstants.fy" optionLabel="value" optionValue="value" class="w-full" placeholder="-- Select FY --" :showClear="true" @change="filterOrders"/>
                </div>
                
                <div class="col-6">
                    <div >
                        <Calendar v-model="poDate" showIcon selectionMode="range" iconDisplay="input" class="w-full" placeholder="PO date (Start - End)" @date-select="filterOrders" :showButtonBar="true" @clear-click="filterOrders"/>
                    </div>
                </div>
                
            </div>
        </div>
        <div class="flex align-items-center justify-content-center mb-1">
            <Button label="Export" icon="pi pi-file-excel" raised v-tooltip.top="'Export Order details'" @click="exportOrders($event)"/>
        </div>
    </div>

    <DataTable :value="filteredOrders" stripedRows showGridlines tableStyle="min-width: 50rem" paginator :rows="100" :rowsPerPageOptions="[100, 200, 500]" scrollable scrollHeight="62vh" :loading="loading1" size="small" ref="ordersTable" paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
    currentPageReportTemplate="{first} to {last} of {totalRecords}" dataKey="id" v-model:filters="filters" filterDisplay="menu" :globalFilterFields="['po_no','department','procurement_officer', 'order_status', 'completedPerc']">
        <Column header="Sl No" >
            <template #body="slotProps">
                {{ slotProps.index + 1 }}
            </template>
        </Column>
        <Column field="po_no" header="PO No.">
            <template #body="slotProps">
                {{ slotProps.data.po_no }}
            </template>
            <template #filter="{ filterModel }">
                <InputText v-model="filterModel.value" type="text" class="p-column-filter" placeholder="Search by PO No." />
            </template>
        </Column>
        <Column field="roc_refs" header="Ref. ROC" :exportable="false">
            <template #body="slotProps">
                <Button v-if="slotProps.data.rocRefs!=null && Object.keys(slotProps.data.rocRefs).length != 0" icon="pi pi-window-maximize" size="small" @click="showRefRocOp($event, slotProps.data.rocRefs)"/>

                <OverlayPanel class="overlay-panel-bg" ref="opRefRoc" dismissable>
                    <div v-for="(roc, index) in refRocs" :key="index">
                        <div class="mb-1">
                            <label class="mr-2"><b> {{1 + index}}. </b></label>
                            <label >{{roc}}</label>
                        </div>
                    </div>
                </OverlayPanel>
            </template>
        </Column>
        <Column field="po_date" header="PO Date" style="width:10%" ></Column>
        <Column field="department" header="DEPT" >
            <template #body="slotProps"> 
                {{ slotProps.data.department }}
            </template>
            <template #filter="{ filterModel }">
                <Dropdown v-model="filterModel.value" :options="departments" placeholder="Select One" class="p-column-filter" showClear>
                    <template #option="slotProps">
                        {{ slotProps.option }}
                    </template>
                </Dropdown>
            </template> 
        </Column>
        <Column field="procurement_officer" header="Proc. Officer" style="width:10%">
            <template #body="slotProps"> 
                {{ slotProps.data.procurement_officer }}
            </template>
            <template #filter="{ filterModel }">
                <Dropdown v-model="filterModel.value" :options="procOfficers" placeholder="Select One" class="p-column-filter" showClear>
                    <template #option="slotProps">
                        {{ slotProps.option }}
                    </template>
                </Dropdown>
            </template>
        </Column>
        <Column field="po_value" header="PO Value">
            <template #body="slotProps">
                {{ formatCurrency(slotProps.data.po_value) }}
            </template>
        </Column>
        <Column field="delivery_period" header="Period (Days)"> days</Column>
        <Column field="order_status" header="OEM Order Status" style="width:12%">
            <template #body="slotProps">
                <Tag :value="slotProps.data.order_status" :severity="statusSeverity(slotProps.data.order_status)" />
            </template>
            <template #filter="{ filterModel }">
                <Dropdown v-model="filterModel.value" :options="orderStatusOptions" placeholder="Select type" class="p-column-filter" showClear>
                    <template #option="slotProps">
                        <Tag :value="slotProps.option" :severity="statusSeverity(slotProps.option)" />
                    </template>
                </Dropdown>
            </template>
        </Column>
        <Column header="Upload PO">
            <template #body="slotProps">
            <div v-if="slotProps.data.doc_url" class="flex">                
                    <div class="flex-initial flex align-items-center justify-content-center ">
                        <Button class="pi pi-file-pdf" severity="danger" size="large" text rounded @click="showDoc(slotProps.data.doc_url)" v-tooltip.top="'View Order Copy'"></Button>
                    </div>
                    <div class="flex-initial flex align-items-center justify-content-center ">
                        <Button icon="pi pi-trash" text rounded severity="warning" v-tooltip.top="'Remove File'" size="large" @click="removeDocument(slotProps.data, slotProps.data.doc_url)"></Button>
                    </div>
            </div>
            <div v-else class="flex">
                <div class="flex-initial flex align-items-center justify-content-center ">
                    <Button icon="pi pi-upload" @click="showFileUploadComponent(slotProps.data)" v-tooltip.top="'Upload Order Copy'"></Button>
                </div>
            </div>
            </template>
        </Column>
        <Column field="completedPerc" header="Delivered(%)" dataType="numeric">
            <template #body="slotProps">
                <!-- {{ slotProps.data.completedPerc+'%' }} --><label v-if="slotProps.data.completedPerc==0">{{ slotProps.data.completedPerc+'%' }}</label>
                
                <ProgressBar v-if="slotProps.data.completedPerc>0" :value="slotProps.data.completedPerc" />
            </template>
            <template #filter="{ filterModel }">
                <InputNumber v-model="filterModel.value" />
            </template>
        </Column>
        <Column header="Details">
            <template #body="slotProps">
                <Button size="small" icon="pi pi-info-circle" @click="setPoState(slotProps.data)"></Button>                
            </template>
        </Column>                                 
        <Column header="Item">
            <template #body="slotProps">
                <Button label="Add" severity="info" size="small" raised @click="setDeptPoStore(slotProps.data)"/>
            </template>
        </Column>
        
    </DataTable>


    <FileUploadComponent v-if="uploadComponent" :visibility="uploadComponent" :poId="poId" :poNo="poNo" @close-upload-dialog="closeFileComponent" documentType="order"></FileUploadComponent>

     <Dialog :visible="deleteFileDialog" modal :closable="false"  :style="{ width: '40rem' }" :breakpoints="{ '1199px': '75vw', '575px': '90vw' }">
        <!-- :header="deleteFileHeader" -->

        <!-- <template #header>                
        </template> -->
        <div class="flex justify-content-between flex-wrap mb-5">
            <div class="flex align-items-center justify-content-center ">
                <div class="text-xl font-semibold">
                    {{ deleteFileHeader }}
                </div>
            </div>
            <div class="flex align-items-center justify-content-center ">
                <i v-if="docDeleteProcessing" class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
            </div>
        </div>

        <div class="flex">
            <div class="flex align-items-center justify-content-center pr-3"><i class="pi pi-exclamation-triangle" style="font-size: 2.5rem"></i></div>
            <div class="flex align-items-center justify-content-center ">
                <p >
                    Are you sure you want to delete the Order Copy?
                </p>
            </div>                            
        </div>
                        
        <template #footer>
        <div class="flex justify-content-end flex-wrap">
            <Button class="flex align-items-center justify-content-center my-1 mx-1" size="small" label="Delete" severity="danger" raised @click="deleteOrderDoc"></Button>
            
            <Button class="flex align-items-center justify-content-center my-1" size="small" label="Close" severity="secondary" text raised @click="deleteFileDialog=false"></Button>
        </div>
        </template>
    </Dialog>

</template>

<script>
import Button from 'primevue/button';
import Calendar from 'primevue/calendar';
import Column from 'primevue/column';
import DataTable from 'primevue/datatable';
import Dropdown from 'primevue/dropdown';
import InputText from 'primevue/inputtext';
import Tag from 'primevue/tag';
import FileUploadComponent from '../../fileUpload/fileUploadComponent.vue';
import { deptOrders } from '@/services/api/v2/apis';
import globalConstants from '@/globalConstants';
import { useDeptPoStore } from '@/stores/deptPoStore';
import { deleteOrderCopy, fetchOrderCopy, getDepartments, procurementOfficerList } from '@/services/apiService';
import OverlayPanel from 'primevue/overlaypanel';
import Dialog from 'primevue/dialog';
import { FilterMatchMode, FilterOperator  } from 'primevue/api'
import InputNumber from 'primevue/inputnumber';
import ProgressBar from 'primevue/progressbar';

export default {
    
    components:{
        DataTable,
        Column,
        Button,
        Dropdown,
        Calendar,
        InputText,
        Tag,
        FileUploadComponent,
        OverlayPanel,
        Dialog,
        InputNumber,
        ProgressBar,
    },
    data(){
        return{
            orders:[],
            filteredOrders:[],
            loading1:false,
            selectedFy:null,
            queryText:null,
            poDate:null,
            selectedStatus:null,
            globalConstants,
            uploadComponent:false,
            docDeleteProcessing:false,
            poNo:null,
            poId:null,
            fileDoc:null,
            deleteFileDialog:false,
            orderStatusOptions:['Not Ordered', 'Partially Ordered', 'Ordered'],
            filters:{
                global: { value: null, matchMode: FilterMatchMode.CONTAINS },    
                po_no: { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }] },  
                department: { operator: FilterOperator.OR, constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }] },
                procurement_officer: { operator: FilterOperator.OR, constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }] },
                order_status: { operator: FilterOperator.OR, constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }] },
                completedPerc:{ operator: FilterOperator.OR, constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }] },
            },
            departments:[],
            procOfficers:[],
        }
    },
    mounted(){        
        this.getOrders();        
        this.getDepartments();
        this.getProcOfficers();
    },
    methods:{
        async getOrders(){
            this.loading1 = true;
            try {
                const response = await deptOrders([]);                
                this.orders = response.data;
                this.filteredOrders = response.data;
                this.loading1 = false;
            } catch (error) {
                this.showErrorToast(error.response.data);
                this.loading1 = false;
            }

        },
        async getDepartments(){
          try {
            const res = await getDepartments();
            this.departments = res.data.map(e=> (e.shortCode))
          } catch (error) {
            this.showErrorToast(error.response.data);
          }  
        },
        async getProcOfficers(){
            try {
                const res = await procurementOfficerList();
                this.procOfficers = res.data.map(e => (e.name));
            } catch (error) {
                this.showErrorToast(error.response.data);
            }
        },
        filterOrders(){
            
            this.filteredOrders = [];
            if(this.selectedStatus==null && this.selectedFy==null && this.queryText==null && this.poDate==null){
                return this.filteredOrders = this.orders
            }

            const [fyStart, fyEnd] = this.selectedFy ?  this.selectedFy.split('-') : [];
            const fy1 = new Date(fyStart, 3, 1);
            const fy2 = new Date(fyEnd, 2, 31);   

            this.orders.forEach((e) => {                                
                const [day, month, year] = e.po_date.split('-');
                const poDate2 = new Date(year, month - 1, day);
                
                if((this.selectedStatus? this.selectedStatus==e.order_status : true) 
                && (this.selectedFy ? (poDate2 >= fy1 && poDate2 <= fy2) : true) 
                && (this.queryText ? (e.poNo.includes(this.queryText) || e.poNo.includes(this.queryText.toUpperCase()) || e.poNo.includes(this.queryText.toLowerCase()) || (e.department.includes(this.queryText) || e.department.includes(this.queryText.toLowerCase()) || e.department.includes(this.queryText.toUpperCase()))) : true) 
                && ((this.poDate && this.poDate[0] && this.poDate[1]) ? (poDate2 >= this.poDate[0] && poDate2 <= this.poDate[1]) : true)
                ){
                    this.filteredOrders.push(e);
                }
                
            });
            
        },
        statusSeverity(status) {
            switch(status) {
                case 'Not Ordered':
                    return 'danger';
                case 'Partially Ordered':
                    return 'warning';
                case 'Ordered':
                    return 'success';
                default:
                    return null;
            }
        },
        exportOrders(){
            this.$refs.ordersTable.exportCSV();
        },
        showRefRocOp(event, data){            
            this.refRocs = []
            this.refRocs = [...data]
            this.$refs.opRefRoc.toggle(event);
        },
        formatCurrency(value) {
            if (value == null || isNaN(value)) return '-';
            return value.toLocaleString('en-IN', { style: 'currency', currency: 'INR' });
        },
        showDoc(url){
            fetchOrderCopy(url).then().catch((error)=>{
                this.showErrorToast(error.response.data);
            })
        },
        removeDocument(po, path){    
            let startIndex = path.indexOf("path=");    
            let url = path.slice(startIndex+5);
            this.poNo = po.id;
            this.fileDoc = url;
            this.deleteFileDialog = true;
            this.deleteFileHeader = 'Order No.: '+po.po_no;
        },
        showFileUploadComponent(data){           
            this.uploadComponent = true;
            this.poNo = data.po_no;
            this.poId = data.id;
            
        },
        closeFileComponent(visible, flag){
            this.uploadComponent = visible;
            this.poId = null;
            if(flag==1){
                this.getOrders();
            }
        },
        deleteOrderDoc(){
            this.docDeleteProcessing = true;
            deleteOrderCopy({
                po:this.poNo, 
                path:this.fileDoc,
                type:'order',
            }).then((res)=>{                
                this.showSuccessToast(res.data);
                this.docDeleteProcessing = false;
                this.deleteFileDialog = false;
                this.getOrders();
            }).catch((error)=>{
                this.showErrorToast(error.response.data);
            });
        },
        setDeptPoStore(data){
            const store = useDeptPoStore();
            store.$patch({
                data:data,
            });
            this.$router.push('add-dept-po');
        },
        setPoState(po){
            const store = useDeptPoStore();
            store.setData(JSON.stringify(po));
            const routedData = this.$router.resolve({
                name: 'department-order-details',
                params:{
                    id:po.id,
                }
            })
            window.open(routedData.href, '_blank')
        },
        showSuccessToast(data){
            this.$toast.add({ severity: 'success', summary: 'Success', detail:data.message, life: 4000 });
        },
        showErrorToast(error){
            this.$toast.add({ severity: 'error', summary: 'Error', detail:error.message, life: 2500 });
        },
    }
}
</script>

<style>

</style>